export default __webpack_public_path__ + "static/media/chevron-right--white.47a6ebd1.svg";